import { ref, computed, Ref } from "vue"

import ElementArray from "./ElementArray";
import DataElement, { DataElementAttributes } from "./DataElement";
import XMLRDBElement from "../xmlrdb-metadata/Element";

export default class SubElements{

  keys: string[];
  parent: DataElement;
  hasChanged: Ref<boolean>;
  [key: string]: ElementArray | any ;


  constructor(subElementMetadata: XMLRDBElement[], dataElement) {
    this.keys = [];
    this.parent = dataElement;

    if (Array.isArray(subElementMetadata)) {
      subElementMetadata.forEach(metadata => {
        this[metadata.id()] = new ElementArray(metadata, dataElement);
        if (!Object.prototype.hasOwnProperty.call(this, metadata.name())) {
          this[metadata.name()] = this[metadata.id()];
        }
        if (metadata.refId()) // Nicht für leeren String oder 0
          this[metadata.refId()] = this[metadata.id()];
        this.keys.push(metadata.id());
      });
    }
    this.hasChanged = computed(() => {
      return this.keys.some(key => this[key].hasChanged.value);
    });

  }

  add(metadata: XMLRDBElement, subElement: DataElement) {
    let metaId = metadata.id();
    if (this[metaId] instanceof ElementArray) {
      this[metaId].addElement(subElement);
    }
  }

}

export type TypedSubElements<T extends DataElementAttributes = DataElementAttributes> = {
  [key: string]: ElementArray<T>;
}